import { call, put, select, takeLatest, all, delay } from 'redux-saga/effects';
import request from 'utils/request';
import { USER_LANG_UPDATE, USER_TOKEN_UPDATE } from '../../utils/urls';
import {
    CHANGE_LANGUAGE_REQUEST
} from './constants';
import {
    changeLanguage, languageUpdateFailure
} from './actions';
import { authFailure } from '../App/actions';
import { resetEkycForm } from '../EkycPage/actions';


export function* changeLanguageRequest({ language }) {
    let requestURL = USER_LANG_UPDATE;

    let requestOptions = {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          language: language
        }),
        headers: {
          'Content-Type': 'application/json',
        }
    };

    try {
        const response = yield call(request, requestURL, requestOptions);
        if (response.status = 'SUCCESS') {
            requestURL = USER_TOKEN_UPDATE;

            requestOptions = {
                method: 'GET',
                credentials: 'include',
                headers: {}
            };
        
            try {
                const response = yield call(request, requestURL, requestOptions);
                if (response.status = 'SUCCESS') {
                    yield put(changeLanguage(language));
                    yield put(resetEkycForm())
                } else {
                    yield put(languageUpdateFailure(response));
                }
            } catch (err) {
                if (
                err.response &&
                (err.response.status === 401 || err.response.status === 403)
                ) {
                    yield put(authFailure());
                } else {
                    yield put(languageUpdateFailure(err));
                }
            }
        } else {
            yield put(languageUpdateFailure(response));
        }
    } catch (err) {
        if (
        err.response &&
        (err.response.status === 401 || err.response.status === 403)
        ) {
            yield put(authFailure());
        } else {
            yield put(languageUpdateFailure(err));
        }
    }
}

export function* languageSaga() {
    yield takeLatest(CHANGE_LANGUAGE_REQUEST, changeLanguageRequest);
}

export default function* rootSaga() {
    yield all([languageSaga()]);
}
